import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const HeaderStyled = styled(Stack)(() => ({
  padding: '32px 32px 0 32px',
}));
